/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import actionCreatorFactory from 'typescript-fsa';
import { Job } from '../../services/playlist';
import { ServerType } from '../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const LOAD_JOBS = 'LOAD_JOBS';
export const loadJobsAction = actionCreator<ServerType>(LOAD_JOBS);

export const DELETE_SCHEDULED_JOB = 'DELETE_SCHEDULED_JOB';
export const deleteScheduledJob = actionCreator<{ serverName: ServerType; triggerId: string; triggerGroup: string }>(
    DELETE_SCHEDULED_JOB
);

export const SET_SCHEDULED_JOBS = 'SET_SCHEDULED_JOBS';
export const setScheduledJobs = actionCreator<{ serverName: ServerType; jobs: Job[] }>(SET_SCHEDULED_JOBS);

export const SET_AVAILABLE_JOBS = 'SET_AVAILABLE_JOBS';
export const setAvailableJobs = actionCreator<{ serverName: ServerType; jobNames: string[] }>(SET_AVAILABLE_JOBS);

export const ENABLE_JOB_SCHEDULER = 'ENABLE_JOB_SCHEDULER';
export const enableJobScheduler = actionCreator<ServerType>(ENABLE_JOB_SCHEDULER);

export const DISABLE_JOB_SCHEDULER = 'DISABLE_JOB_SCHEDULER';
export const disableJobScheduler = actionCreator<ServerType>(DISABLE_JOB_SCHEDULER);

export const SET_JOB_SCHEDULER_STATE = 'SET_JOB_SCHEDULER_STATE';
export const setJobSchedulerState = actionCreator<{ serverName: ServerType; enabled: boolean }>(SET_JOB_SCHEDULER_STATE);

export const SET_SHOW_CREATE_JOB_FORM_ACTION = 'SET_SHOW_CREATE_JOB_FORM_ACTION';
export const setShowCreateJobFormAction = actionCreator<{ serverName: ServerType; show: boolean }>(
    SET_SHOW_CREATE_JOB_FORM_ACTION
);

export const JOB_MANAGEMENT_SET_SERVER_AVAILABLE = 'JOB_MANAGEMENT_SET_SERVER_AVAILABLE';
export const jobManagementSetServerAvailable = actionCreator<{ serverName: ServerType; available: boolean }>(
    JOB_MANAGEMENT_SET_SERVER_AVAILABLE
);

export interface CreateJobActionParams {
    serverName: ServerType;
    jobId: string;
    immediately: boolean;
    seconds: string;
    minute: string;
    hours: string;
    dayOfMonth: string;
    months: string;
    daysOfWeek: string;
    years: string;
}
export const CREATE_JOB_ACTION = 'CREATE_JOB_ACTION';
export const createJobAction = actionCreator<CreateJobActionParams>(CREATE_JOB_ACTION);
